<template>
  <div class="white_bg">
    <div class="inner">

      <div class="jobRequestList hiddenScrollbar" style="overflow: auto">
        <div class="jobRequestItem roundBorder4" style="background: #F5F5F5;" v-for="(dataItem, i) in dataList"
          :key="i">
          <div class="padding12">
            <div class="clearfix font14r">
              <div style="display: flex;width: 100%;justify-content: space-between;margin-bottom: 8px;">
                <div style="display: flex;">
                  <img style="width: 36px;height: 36px;border-radius: 50%;margin-left: 8px;"
                    :src="dataItem ? dataItem.headImg : ''" :alt="dataItem ? dataItem.headImg : ''">
                  <div class="applicantName">{{ dataItem ? cutString(dataItem.name, 9) : '1' }}</div>
                </div>
                <div class="orange educations">
                  <span>{{ dataItem ? (dataItem.educationBackground || "暂无学历") : "暂无学历"}}</span>
                  <span>&nbsp;|&nbsp;{{ dataItem ? (dataItem.educationCertificate || "暂无证书") : "暂无证书"}}</span>
                </div>
              </div>
              <div class="fl">
                <p>意向岗位：{{ dataItem ? formatJobName(dataItem.jobName) : '' }}</p>
                <p>期望薪资： <span>{{ dataItem ? dataItem.salaryMin || "面议" : "面议" }}
                    <span v-if="dataItem.salaryMin">千</span>
                  </span>
                  <span v-if="dataItem.salaryMax && dataItem.salaryMin">
                    &nbsp;-&nbsp;{{ dataItem ? dataItem.salaryMax || "面议" : "面议" }}
                    <span v-if="dataItem.salaryMax">千</span>
                  </span>
                  <span v-if="dataItem.salaryMin && dataItem.salaryMax">/月</span>
                </p>
              </div>
            </div>
            <div class="clearfix font12r" style="color: #8994A9">
              <!-- <div class="fl"> 投递时间：{{dataItem ? formatDateTime(dataItem.createTime) : ''}}</div> -->
              <div class="fr">
                <button class="button" style="padding: 0 16px;background: #F0F0F0;border: 1px solid #E9E9E9;;color: #5B616C;
                                    width: auto; min-width: auto; height: 22px; line-height: 22px;margin-right: 16px;"
                  @click="removeDataItem(dataItem)">删除</button>
                <button class="button redButton" style="padding: 0 16px;
                                    width: auto; min-width: auto; height: 22px; line-height: 22px;"
                  @click="viewDetail(dataItem)">联系</button>
              </div>
            </div>
          </div>
        </div>
        <div class="alignCenter colorCCC bold" v-show="dataList.length < 1">
          <img src="notice/no_content.png" width="206" height="143" alt="无内容" style="margin-top: 60px;" />
        </div>
      </div>

    </div>

    <jobRequestDetailDrawer ref="detailDrawer" title="" />
  </div>
</template>

<script>
import appHelper from "@util/appHelper";
import generalCmpPart from '@comp/part/generalCmpPart';

// config
import appConfig from '../../../appConfig';

// modules
import jobRequestDetailDrawer from './jobRequestDetailDrawer';

// util
import numberHelper from "@util/numberHelper";
import stringHelper from "@util/stringHelper";

const config = {
  apiConfig: {
    list: {
      url: appConfig.apiBaseUrl + 'portal/recruit/seeker/getSameSeekerList',
      dataPath: 'data.records',
      totalPagePath: 'data.pages',
      dataColumnMapping: {
        // userName : 'name''
      }
    },
    remove: {
      url: appConfig.apiBaseUrl + 'portal/recruit/seeker/remove',
      method: 'DELETE'
    }
  },
  demoJobNameList: [
    '幼儿教师',
    '小班辅导员',
    '教务老师'
  ]
};

export default {
  extends: generalCmpPart,
  components: { jobRequestDetailDrawer },
  data () {
    return {
      apiConfig: config.apiConfig,
      enableDataList: true,
      autoLoadDataList: appConfig.mode != 'demo',
    }
  },
  methods: {
    reloadDataList () {
      if (!this.dataList.length) {
        appHelper.showHint("暂无数据哦~");
      }
    },
    viewDetail (dataItem) {
      this.$refs.detailDrawer.loadDataItem(dataItem.id);
      this.$refs.detailDrawer.open();
    },
    onRemoveDataItem () {
      this.reloadDataList();
    },
    formatJobName (jobNames) {
      if (jobNames.length) {
        return jobNames.join("、");
      }
      return "无期望岗位";
    },
    cutString (str, len) {
      //length属性读出来的汉字长度为1
      if (str) {
        if (str.length * 2 <= len) {
          return str;
        }
        var strlen = 0;
        var s = "";
        for (var i = 0; i < str.length; i++) {
          s = s + str.charAt(i);
          if (str.charCodeAt(i) > 128) {
            strlen = strlen + 2;
            if (strlen >= len) {
              return s.substring(0, s.length - 1) + "...";
            }
          } else {
            strlen = strlen + 1;
            if (strlen >= len) {
              return s.substring(0, s.length - 2) + "...";
            }
          }
        }
        return s;
      }
      return str
    }
  }
}
</script>

<style lang="scss" scoped>
.orange {
  color: #ffa724;
}
.jobRequestItem {
  margin-bottom: 12px;
}
.applicantName {
  width: fit-content;
  height: 22px;
  font-size: 16px;
  font-weight: 500;
  line-height: 18px;
  color: #333333;

  margin-left: 17px;
  margin-top: 6px;
}
.educations {
  margin-top: 6px;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
}
</style>
